import { motion } from 'motion/react';
import { Star, Quote } from 'lucide-react';
import { GlassCard } from '../ui/GlassCard';

export const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Aleksandra N.",
      role: "CEO, AI Agency",
      content: "Prestige Gold zmieniło moje postrzeganie biznesu. Narzędzia, które tu dostałam, pozwoliły mi zeskalować agencję x10 w pół roku.",
      rating: 5
    },
    {
      name: "Marek D.",
      role: "Inwestor",
      content: "Szukałem konkretów, a nie lania wody. Tutaj dostałem czystą esencję wiedzy i kontakty, które są bezcenne.",
      rating: 5
    },
    {
      name: "Julia K.",
      role: "Freelancer",
      content: "Społeczność jest niesamowita. Każdy sobie pomaga, a poziom merytoryczny dyskusji to zupełnie inna liga.",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="min-h-screen flex items-center justify-center py-20 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 w-full">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-6xl font-display font-bold text-text-main mb-4">
            GŁOS <span className="text-primary">ELITY</span>
          </h2>
          <p className="text-text-muted max-w-2xl mx-auto">
            Zobacz, co mówią ci, którzy już odważyli się sięgnąć po więcej.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <GlassCard className="h-full p-8 flex flex-col relative group hover:-translate-y-2 transition-transform duration-300">
                <Quote className="absolute top-6 right-6 text-primary/10 w-12 h-12" />
                
                <div className="flex gap-1 mb-6 text-primary">
                  {[...Array(item.rating)].map((_, i) => (
                    <Star key={i} size={16} fill="currentColor" />
                  ))}
                </div>

                <p className="text-text-main text-lg leading-relaxed mb-8 flex-1">
                  "{item.content}"
                </p>

                <div className="border-t border-border pt-6">
                  <div className="font-bold text-text-main">{item.name}</div>
                  <div className="text-xs font-mono text-primary uppercase tracking-wider">{item.role}</div>
                </div>
              </GlassCard>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
